define('adminGenericEmailDomainsListHeaderToolsView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'bootbox',
  'tableHeaderFieldView',
  'template!adminGenericEmailDomainsListHeaderToolsView'
], function (
  Module,
  App,
  _,
  $,
  Bootbox,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-generic-email-domains-list-header-tools-view table-field-view',

    events: {
      'click .btn-create': 'onCreate'
    },

    serializeData: function () {
      return {
        createLabel: _.i18n('admin.genericEmailDomains.create', null, 'Add domain')
      };
    },

    onCreate: function () {
      var tableView = this.options && this.options.tableView;
      Bootbox.prompt(
        _.i18n('admin.genericEmailDomains.createTitle', null, 'New generic email domain (e.g. gmail.com)'),
        function (value) {
          if (value === null) { return; }
          var domain = $.trim(value || '').toLowerCase();
          if (!domain) { return; }
          App.request('genericEmailDomains:create', { domain: domain }).done(function () {
            if (tableView && tableView.refresh) { tableView.refresh(); }
          }).fail(function (xhr) {
            if (xhr && xhr.status === 409) {
              Bootbox.alert(_.i18n('admin.genericEmailDomains.domainTaken', null, 'That domain already exists.'));
            } else {
              Bootbox.alert(_.i18n('common.error', null, 'Something went wrong. Please try again.'));
            }
          });
        });
    }
  });
});

